import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GoogleChartComponent } from 'angular-google-charts';
import { ServicesSunsetService } from '../../services-sunset.service';

declare var google: any;

@Component({
  selector: 'app-dashboardoc',
  templateUrl: './dashboardoc.component.html',
  styleUrls: ['../../../app.component.css']
})
export class DashboardocComponent implements OnInit, AfterViewInit {

 
  @ViewChild('pieChart') pieChart: ElementRef;

  
  @Input() busqueda: string;
  @Input() titulo: string;
  @Input() especial: string;

  data: any[];
  procesos: any[];
  enproceso: any[];
  sinprocesar: any[];
       
  drawChart = () => {

    var resultado;

    try {

      this.data = [];

      this._servicios.consultarDashboard(this.busqueda,0,0).subscribe(

        (dato: any) => {
    
          if (this.especial === 'SI') {

          this.procesos = ['Procesados',dato.consulta[0]["procesados"] *1];
          this.enproceso = ['En proceso',dato.consulta[0]["en_proceso"] *1];
          this.sinprocesar = ['Sin procesar',dato.consulta[0]["sin_procesar"] *1];

          resultado = new google.visualization.arrayToDataTable([['Procesos','Valor'],this.procesos, this.enproceso, this.sinprocesar
          
        ]);

              } else {

                resultado = new google.visualization.DataTable();
                resultado.addColumn('string', 'Status');
                resultado.addColumn('number', 'Total');
              
                  dato.consulta.forEach(element => {
                  
                  const resul = [element.status, element.total * 1];
                  resultado.addRows([resul]);

                });

              
            }
      

          const options = {
            legend: { position: 'left', alignment: 'center' },
            title: this.titulo,
            
            chartArea: {left:70, right:60, width: '100%', height: '85%'},
            hAxis: {
              title: 'Total',
              minValue: 0
            },
            vAxis: {
              title: 'Procesos'
            },
            is3D:true
          };    
      
          const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
          
          chart.draw(resultado, options);
    
    
        }
  
      )
  



  
      
    } catch (error) {
      
      console.log(error);

    }

  
  }

  constructor(private _servicios:ServicesSunsetService) {

      

  }


  ngOnInit() {

  

  }

  ngAfterViewInit() {


    
    google.charts.load("current", {packages:["corechart"]});

    
    google.charts.setOnLoadCallback(this.drawChart);


  }

  

  }
  
  
